module.exports = "/static/assets/aa3c3a337c60549f94f812e28b16b91b.png";